export default class Zoom {
	constructor(scope) {
		this.scope = scope;
	}
	changeZoom(oldZoom, delta) {
		let factor;
		factor = 1.05;
		if (delta < 0) {
			return oldZoom * factor;
		}
		if (delta > 0) {
			return oldZoom / factor;
		}
		return oldZoom;
	}

	changeCenter(oldCenter, deltaX, deltaY, factor) {
		let offset;
		offset = new this.scope.paper.Point(deltaX, -deltaY);
		offset = offset.multiply(factor);
		return oldCenter.add(offset);
	}

	stableChangeZoom(oldZoom, delta, c, p) {
		let a;
		let beta;
		let newZoom;
		let pc;
		newZoom = Math.max(0.1, Math.min(1.5, this.changeZoom(oldZoom, delta)));
		beta = oldZoom / newZoom;
		pc = p.subtract(c);
		a = p.subtract(pc.multiply(beta)).subtract(c);
		return [ newZoom, a ];
	}
}
